import React from "react";

export const getFormFields = (locale: string = 'en') => [
    {
        name: 'lastName',
        type: 'text',
        placeholder: "form_lastname",
        validation: {
            required: "form_lastname_required",
            maxLength: {
                value: 30,
                message: "form_lastname_max",
            },
        },
    },
    {
        name: 'firstName',
        type: 'text',
        placeholder: "form_firstname",
        validation: {
            required: "form_firstname_required",
            maxLength: {
                value: 30,
                message: "form_firstname_max",
            },
        },
    },
    {
        name: 'email',
        type: 'text',
        placeholder: "form_email",
        validation: {
            required: "form_email_required",
            pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "form_email_invalid",
            },
            maxLength: {
                value: 100,
                message: "form_email_max",
            },
        },
    },
    {
        type: 'text',
        name: 'phone',
        placeholder: "form_phone",
        validation: {
            required: "form_phone_required",
            maxLength: {
                value: 15,
                message: "form_phone_max",
            },
            minLength: {
                value: 10,
                message: "form_phone_min",
            }
        }
    },
    {
        type: 'citylist',
        name: 'region',
        placeholder: "form_region",
        validation: {
            required: "form_region_required"
        }
    },
    {
        type: 'textarea',
        name: 'message',
        placeholder: "form_message",
        validation: {
            maxLength: {
                value: 200,
                message: "form_message_max",
            }
        },
        rows: 6
    }
];
